import parentRoute from '@/mixins/parent-route.js'

import helpAddressEnImage from '@/assets/images/help_address_en.png'
import helpAddressPlImage from '@/assets/images/help_address_pl.png'
import helpDeliveryKeyEnImage from '@/assets/images/help_delivery_key_en.png'
import helpDeliveryKeyPlImage from '@/assets/images/help_delivery_key_pl.png'
import helpMessageEnImage from '@/assets/images/help_message_en.png'
import helpMessagePlImage from '@/assets/images/help_message_pl.png'

export default {
  name: 'DeliveryCode',
  mixins: [parentRoute],
  data: function () {
    return {
      helpAddressEnImage,
      helpAddressPlImage,
      helpDeliveryKeyEnImage,
      helpDeliveryKeyPlImage,
      helpMessageEnImage,
      helpMessagePlImage,
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
  },
}
